export const isTagVoid = (tag: string): boolean => {
  // Based on the list from the React source-code
  const voidHTMLTags = [
    'area',
    'base',
    'br',
    'col',
    'embed',
    'hr',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr',
    'menuitem',
  ];

  return voidHTMLTags.includes(tag?.toLowerCase());
};

// Check based on the same check as in react source-code
export const validateReactElementProps = (tag: string, props: Record<string, unknown>, children: unknown): boolean => {
  if (!props) return true;

  if (isTagVoid(tag)) {
    if (!(!props.children && !props.dangerouslySetInnerHTML && !children)) {
      return false;
    }
  }

  if (props.dangerouslySetInnerHTML) {
    if (props.children && children) {
      return false;
    }

    if (!(typeof props.dangerouslySetInnerHTML === 'object' && '__html' in props.dangerouslySetInnerHTML)) {
      return false;
    }
  }

  if (!(!props.style || typeof props.style === 'object')) {
    return false;
  }

  return true;
};
